import React from 'react';
import clsx from 'clsx';

interface DisplayQuoteProps {
    image?: { src: string, srcMobile: string };
    imageAlt?: string;
    imageLeft?: boolean;
    imageRight?: boolean;
    quoteText: string;
    author: string;
    position: string;
    color?: 'primary' | 'secondary' | 'light' | string;
    articleType?: 'news' | 'insights';
}

export default function DisplayQuote({
    image,
    imageAlt,
    imageLeft,
    imageRight,
    quoteText,
    author,
    position,
    color,
    articleType
}: DisplayQuoteProps) {
    const quoteClass = clsx({
        'display-quote': imageLeft,
        'display-quote display-quote--right': imageRight,
        'display-quote--flex': !image, // Add this class if image is not provided
    });

    const textClass = clsx({
        'text-primary': color === 'primary',
        'text-secondary': color === 'secondary',
        'text-light': color === 'light',
    });

    const textArticleType = clsx({
        'text-primary': articleType === 'insights',
        'text-secondary': articleType === 'news',
    });

    return (
        <div className={quoteClass}>
            {image && 
            <div className="display-quote__image">
                <figure className="display-quote__figure"> 
                    <picture className="display-quote__picture">
                        <source media="(max-width: 767px)" srcSet={image.srcMobile} />
                        <img className="display-quote__img" src={image.src} alt={imageAlt} loading="lazy" />
                    </picture>
                </figure>
            </div>
            }
            <div className="display-quote__content">
                <div className={clsx('display-quote__text', textClass, textArticleType)} dangerouslySetInnerHTML={{ __html: quoteText }} suppressHydrationWarning></div>
                <div className="display-quote__author-position">
                    <p className={clsx('display-quote__author', textClass, textArticleType)}>{author}</p>
                    <p className={clsx('display-quote__position', textClass, textArticleType)}>{position}</p>
                </div>
            </div>
        </div>
    );
}
